import React from "react";
import "./style.css";

/**
 * @typedef {Object} BusinessDetails
 * @property {string} name
 * @property {string} email
 * @property {string} address
 * @property {string} phone
 * @property {string} businessNumber
 * @property {string} website
 * @property {string} owner
 */

/**
 * @param {{
 * 	data: BusinessDetails,
 * 	onChange: (data: BusinessDetails) => void
 * }} props
 */
export default function BusinessDetailsForm({ data, onChange }) {
	const handleChange = (field, value) => {
		onChange({ ...data, [field]: value });
	};

	return (
		<div className="invoice-section">
			<h3 className="invoice-section-title">From (Your Business)</h3>

			<div className="business-grid">
				<div className="field">
					<label className="label" htmlFor="from-name">
						Business Name
					</label>
					<input
						id="from-name"
						className="invoice-input"
						type="text"
						placeholder="Your Company Name"
						value={data.name || ""}
						onChange={(e) => handleChange("name", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="from-email">
						Email
					</label>
					<input
						id="from-email"
						className="invoice-input"
						type="email"
						placeholder="email@company.com"
						value={data.email || ""}
						onChange={(e) => handleChange("email", e.target.value)}
					/>
				</div>

				<div className="field field--full">
					<label className="label" htmlFor="from-address">
						Address
					</label>
					<input
						id="from-address"
						className="invoice-input"
						type="text"
						placeholder="123 Business St, City, State, ZIP"
						value={data.address || ""}
						onChange={(e) => handleChange("address", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="from-phone">
						Phone
					</label>
					<input
						id="from-phone"
						className="invoice-input"
						type="tel"
						placeholder="+27 12 345 6789"
						value={data.phone || ""}
						onChange={(e) => handleChange("phone", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="from-business-number">
						Business No./Tax Ref No.
					</label>
					<input
						id="from-business-number"
						className="invoice-input"
						type="text"
						placeholder="ABN / Tax ID"
						value={data.businessNumber || ""}
						onChange={(e) => handleChange("businessNumber", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="from-website">
						Website
					</label>
					<input
						id="from-website"
						className="invoice-input"
						type="url"
						placeholder="www.yourcompany.com"
						value={data.website || ""}
						onChange={(e) => handleChange("website", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="from-owner">
						Owner Name
					</label>
					<input
						id="from-owner"
						className="invoice-input"
						type="text"
						placeholder="John Doe"
						value={data.owner || ""}
						onChange={(e) => handleChange("owner", e.target.value)}
					/>
				</div>
			</div>
		</div>
	);
}
